var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "base-card-item",
      class: { "base-card--with-background": _vm.backgroundImage },
    },
    [
      _c("div", { staticClass: "base-card-image" }, [
        _c(
          "picture",
          {
            directives: [
              {
                name: "lazyload",
                rawName: "v-lazyload",
                value: { src: _vm.imageUrl, variant: "resort-card" },
                expression: "{ src: imageUrl, variant: 'resort-card' }",
              },
            ],
            staticClass: "wrapper",
          },
          [
            _c("img", {
              staticClass: "image",
              attrs: {
                src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                alt: _vm.imageAlt,
              },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.label
          ? _c("div", { staticClass: "base-card-label" }, [
              _vm._v("\n      " + _vm._s(_vm.label) + "\n    "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "base-card-content" }, [_vm._t("content")], 2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "base-card-utility" },
        [
          _vm._t("additional-info"),
          _vm._v(" "),
          _c("div", { staticClass: "base-card-ctas" }, [_vm._t("ctas")], 2),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }